module.exports = __webpack_public_path__ + "static/img/erqq.2e2888a4.png";